import APIService from './APIService';

export default {
  listarUsuariosBloqueados(bdgdVersaoId) {
    return APIService.apiCall().get(`/permissoes-edicao-bdgd/listar-usuarios-bloqueados/${bdgdVersaoId}`);
  },
  sincronizarUsuariosBloqueados(bdgdVersaoId, usuariosBloqueadosIds) {
    return APIService.apiCall().post(
      `/permissoes-edicao-bdgd/sincronizar-usuarios-bloqueados/${bdgdVersaoId}`,
      JSON.stringify({ usuarios_bloqueados_ids: usuariosBloqueadosIds })
    );
  },
  listarVersoesBloqueadas(usuarioId) {
    return APIService.apiCall().get(`/permissoes-edicao-bdgd/listar-versoes-bloqueadas/${usuarioId}`);
  },
  sincronizarVersoesBloqueadas(usuarioId, bdgdVersoesBloqueadasIds) {
    return APIService.apiCall().post(
      `/permissoes-edicao-bdgd/sincronizar-versoes-bloqueadas/${usuarioId}`,
      JSON.stringify({ bdgd_versoes_bloqueadas_ids: bdgdVersoesBloqueadasIds })
    );
  }
};
